import { useTranslation } from 'react-i18next';

import { AIExplanation } from './components/AiExplanation';
import { IntentionMapping } from './components/IntentionMapping';
import { ProductsNavigated } from './components/ProductNavigated';

export function SimilarProducts() {
  const { t } = useTranslation();

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-6">
      <h4 className="mb-4 text-xl font-semibold">
        {t('pages.Personalization.components.SimilarProducts.title')}
      </h4>
      <div className="flex flex-col gap-6 md:flex-row">
        <ProductsNavigated />
        <IntentionMapping />
      </div>
      <AIExplanation />
    </div>
  );
}
